/* eslint-disable */
export default {
    dashboard: 'Dashboard',
    cloud: 'Cloud',
    home: 'Home',
    admin: 'Admin',
    learn: 'Learn',
    company: 'Company',
    account: 'Account',

    street: 'Street',
    apartment: 'Apartment',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    country: 'Country',
    phone: 'Phone Number',
    email: 'Email',
    primaryEmail: 'Primary Email',
    change: 'Change',
    cancel: 'Cancel',
    submit: 'Submit',
    saveChanges: 'Save Changes',
    changesSaved: 'Changes saved successfully.',
    save: 'Save',
    saved: 'Saved',
    line1: 'Address Line 1',
    line2: 'Address Line 2',
    gender: 'Gender',
    ethnicity: 'Ethnicity',
    dob: 'Date of Birth',
    timeZone: 'Time Zone',
    personalEmail: 'Personal Email Address',
    firstName: 'First Name',
    lastName: 'Last Name',
    middleName: 'Middle Name',
    jobTitle: 'Job Title',
    personalInfo: 'Personal Info',
    settings: 'Settings',
    profilePreview: 'Profile Preview',
    emailAddress: 'Email Address',
    password: 'Password',
    savePassword: 'Save Password',
    choosePassword: 'Choose a Password',
    createPassword: 'Create a Password',
    tooWeak: 'Too Weak',
    averageStrength: 'Average Strength',
    strongPassword: 'Strong Password',
    security: 'Security',
    logIn: 'Log In',
    loggedIn: 'You\'re logged in!',
    signOut: 'Sign Out',
    logout: 'Log Out',
    enterPassword: 'Enter your password',
    changePassword: 'Change Password',
    updatePassword: 'Update Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    confirmPassword: 'Confirm Password',
    createNewPasswordTitle: 'Create new password',
    createNewPasswordSubtitle: 'Create a new password different from your old one. It must be at least 8 characters and contain one number and one capital letter.',
    setPassword: 'Set Password',
    characterCount: 'at least 8 characters',
    uppercaseCount: 'at least one uppercase character',
    numeralCount: 'at least one number',
    specialCount: 'at least one special character such as !@#$%^&*',
    passwordSaved: 'Your password is saved.',
    passwordChanged: 'Password successfully changed',
    forgotPasswordTitle: 'Forgot Password.',
    forgotPasswordSubtitle: 'Enter the email address associated with your account and we\'ll send an email with instructions to reset your password.',
    sendInstructions: 'Send Instructions',
    checkEmail: 'Check your email.',
    passwordEmailSent: 'An email was sent to {0} with instructions to reset your password.',
    tryAnotherEmail: 'try another email',
    passwordNoEmail: 'If you didn\'t receive the email, try checking your spam folder or {0}.',
    passwordSuccessful: 'You have successfully set your password, now you can login to start learning.',
    setupComplete: 'Account Setup Complete',
    createAccount: 'Create an account',
    welcome: 'Welcome, {name}',
    setupAlmostComplete: 'Your CareerStep account is almost complete, you just need to set up your password. Click the button to get started.',
    finishAccountSetup: 'Finish account setup',
    continueLogInMsg: 'You\'ll log in with your email address {0} and password', // {0} refers to the first element contained within the i18n tag e.g. <i18n path="continueLogInMsg">{0}</i18n>
    enterAnEmail: 'Enter an email address',
    enterEmail: 'Enter your e-mail address',
    emailUnavailable: 'The specified email address is unavailable.',
    logInAcct: 'Log in.',
    logInToLearn: 'Log in to start learning.',
    shippingAddress: 'Shipping Address',
    billingAddress: 'Billing Address',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot Password?',
    back: 'Back',
    backToLogin: 'Back to Login',
    backToEdit: 'Back to Edit',
    backToSearchResults: 'Back to Search Results',
    close: 'Close',
    about: 'About',
    locations: 'Locations',
    search: 'Search',
    searchLocations: 'Search Locations',
    aboutUs: 'About Us',
    quickFacts: 'Quick Facts',
    editProfile: 'Edit Profile',
    headquarters: 'Headquarters',
    numEmployees: 'Number of Employees',
    founded: 'Founded',
    links: 'Links',
    delete: 'Delete',
    accountSettings: 'Account Settings',
    profile: 'Profile',
    locationProfile: 'Location Profile',
    notRequired: 'Not required',
    routeError: 'Route Error',
    yes: 'Yes',
    no: 'No',

    // Company Settings
    companySettings: 'Company Settings',
    viewProfile: 'View Profile',
    companyProfile: 'Company Profile',
    hiringPolicies: 'Hiring Policies',
    jobOpenings: 'Job Openings',
    agreement: 'Agreement',
    users: 'Users',
    publicProfileInfo: 'Public Profile Information',
    companyLogo: 'Company Logo',
    addImage: 'Add Image',
    bannerImage: 'Banner Image',
    replaceBannerImage: 'Replace Banner Image',
    companyName: 'Company Name',
    companyWebsite: 'Company Website',
    socialMedia: 'Social Media',
    headquartersCity: 'Headquarters City',
    headquartersState: 'Headquarters State',
    companyDescription: 'Company Description',
    companyDescriptionAbout: 'Tell candidates about your company and why it\'s a great place to work...',
    locationDescriptionAbout: 'Tell candidates about this location and why it\'s a great place to work...',
    positions: 'Positions',
    savePosition: 'Save Position',
    addPosition: 'Add Position',
    addLocation: 'Add Location',
    locationSetup: 'Location Setup',
    position: 'Position',
    positionsWeHire: 'Positions we Hire',
    hireTrainees: 'Will Hire Trainees',
    hostExternships: 'Will Host Externships',
    locationName: 'Location Name',
    locationAdminEmail: 'Location Admin Email',
    sendSetupInstructions: 'Send Setup Instructions',
    advancedLocationSetup: 'Advanced Location Setup',
    locationInfo: 'Location Info',
    streetAddress: 'Street Address',
    streetAddressLine2: 'Street Address Line 2',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    locationType: 'Location Type',
    locationAdmin: 'Location Admin',
    selectLocationAdmin: 'Select Location Admin',
    selectAnAdmin: 'Select an Admin',
    pendingFinalSetup: 'Pending Final Setup',
    finishSetup: 'Finish Setup',
    phoneNumber: 'Phone Number',
    next: 'Next',
    locationVisibility: 'This location won’t be publicly visible until the location administrator finishes setup. If you prefer to finish setup yourself, click Advance Location Setup.',
    goToProfile: 'Go To {0} Profile',
    jobs: 'Jobs',
    respondInterviewRequest: 'Respond To Interview Request',
    daysAgo: 'day(s) ago',
    searchOpenings: 'Search Job Openings',
    jobDetails: 'Job Details',
    jobType: 'Job Type',
    salary: 'Salary',
    numberOfHiresForRole: 'Number of hires for this role',
    hires: 'hire(s)',
    qualifications: 'Qualifications',
    fullJobDescription: 'Full Job Description',
    schedule: 'Schedule',
    licenseCertification: 'License/Certification',
    pendingLocationProfile: 'Fill in the required fields for the location\'s public profile, which will be visible to job candidates',
    pendingPositions: 'Review this information provided by your company and make any adjustments. This info will not be shown in the location\'s public profile.',
    pendingPolicies: 'Review this information provided by your company and make any adjustments. This info will not be shown in the location\'s public profile.',
    pendingUsers: 'If you\'d like, add users who need access to manage the location\'s settings. When you\'re done, save and publish the location so its public profile is visible to job candidates.',
    saveAndPublish: 'Save and Publish',
    locationDescription: 'Location Description',
    locationAddress: 'Location Address',
    websites: 'Websites',
    locationWebsite: 'Location Website',
    howManyExterns: 'How Many Externs',
    drugTestRequired: 'Drug Test Required?',
    backgroundTestRequired: 'Background Test Required?',
    healthInsuranceRequired: 'Health Insurance Required?',
    physicalExamRequired: 'Physical Exam Required?',
    cprCertRequired: 'CPR Certification Required?',
    requiredImmunizations: 'Required Immunizations',
    adtlRequirements: 'Additional Requirements',
    policies: 'Policies',
    addLocationImage: 'Add Image of Location',
    locationSettings: 'Location Settings',
    mustBeNumber: 'Value must be a number',
    turnOnNotifications: 'Turn On Notifications',
    turnOffNotifications: 'Turn Off Notifications',

    //Privacy Settings
    privacy: 'Privacy',
    dataPrivacy: 'Data Privacy',
    tacAgreement: 'By using this website, you agree to the {0}',
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    acceptableUsePolicy: 'Acceptable Use Policy',
    keepSettings: 'Nevermind, Keep My Current Settings',
    optOut: 'Opt Out',
    optOutSale: 'Opt Out of "Sale"',
    optOutSaleDisclosure: `You are about to opt out of CarrusLearn\'s disclosure of certain
    information about you to companies like our advertising-related partners and content programmers,
    as further described in our {0}.`, // {0} refers to the first element contained within the i18n tag e.g. <i18n path="optOutSaleDisclosure">{0}</i18n>
    requestInfo: 'Request Info',
    rightToKnowInformation: 'You have the right to know what personal information we have about you and how it\'s used.',
    rightToKnow: 'Right to know',
    doNotSellPersonalInfo: 'Do Not Sell My Personal Information',
    changeStatus: 'Change Status',
    startDeletion: 'Start Deletion',
    rightToDelete: 'Right to Delete',
    rightToOptOut: 'Right to opt out of sale',
    rightToNonDiscrmination: 'Right to non-discrimination',
    privacyRights: `We care about your privacy and are committed to doing the right thing.
    We'll never deny you service, charge you a different price, or provide a different level of
    quality because you choose to exercise your privacy rights.`,
    rightNotToSell: 'You have the right to ask us not to sell your personal information.',
    rightToDeleteInfo: 'You have the right to ask us to delete your personal information.',
    todo: 'To do...',
    profileVisibility: 'Profile Visibility',
    private: 'Private',
    public: 'Public',
    profilePrivateInfo: 'Your profile will not be displayed when searching. You may share a link to your profile.',
    profilePublicInfo: 'Everyone can see your full name, skills, work experience, education, and can click on your profile.',

    // Work Education
    description: "Description",
    workeducation: 'Work & Education',
    workExperience: 'Work Experience',
    workInformation: 'Work Information',
    desiredPosition: 'Desired Position',
    topicsOfInterest: 'Topics of Interest',
    jobsOfInterest: 'Jobs of Interest',
    statesOfInterest: 'States of Interest',
    currentPosition: 'Current Position',
    pastEmployment: 'Past Employment',
    currentIncome: 'Current Income',
    currentTitle: 'Current Title',
    education: 'Education',
    educationInformation: 'Education Information',
    highSchoolAttended: 'High School Attended',
    yearOfGraduation: 'Year of Graduation',
    graduationYear: 'Graduation Year',
    degree: 'Degree',
    institution: 'Institution',
    majors: 'Majors',
    startDate: 'Start Date',
    endDate: 'End Date',
    removeWorkExperience: 'Remove this work experience?',
    removeEducation: 'Remove this education?',
    achievement: 'Achievement',
    noWorkExperience: 'No work experience listed.',
    noEducationListed: 'No education listed.',
    requiredFieldShouldNotBeEmpty: 'The required field should not be empty.',
    pleaseEnterAJobTitle: 'Please enter a job title.',
    pleaseEnterACompanyName: 'Please enter a company name.',
    pleaseEnterACity: 'Please enter a city.',
    pleaseSelectAState: 'Please select a state.',
    pleaseSelectAStartDate: 'Please select a start date.',
    pleaseSelectAnEndDate: 'Please select an end date.',
    pleaseSelectADegree: 'Please select a degree.',
    pleaseEnterAnInstitution: 'Please enter an institution.',
    type: 'Type...',

    // Tooltip text for MVP
    manageYourAchievements: 'Manage your achievements<br/>(badges, certificates)',
    makeProfileVisible: 'Make your profile visible to employers',
    manageYourPassword: 'Manage your password',
    manageYourDataPrivacy: 'Manage your data privacy',
    seeProfilePreview: 'See how your profile looks to employers',
    comingSoon: 'Coming soon',

    // Career
    career: 'Career',
    programCompletionDate: 'Program Completion Date',
    estimatedCompletionDate: 'Estimated Completion Date',
    calculatedProgramCompletionDateLabelText: `Your estimated program completion date is listed below.
    Feel free to change it based on your preferences:`,
    programCompletionDateLabelTextMvp: 'Please enter the date you completed your program, or the date you plan to complete the program.',
    completionDate: 'Completion Date',
    seekingEmployment: 'Seeking Employment',
    onSite: 'On-site',
    remote: 'Remote',
    location: 'Location',
    yourLocation: 'Your Location',
    needExternship: 'Need Externship',
    availability: 'Availability',
    fullTime: 'Full-time',
    partTime: 'Part-time',
    otherLanguages: 'Other Languages',
    missingCityZipInputLabel: 'Please select a city or enter a zipcode.',
    pleaseSelectAnOption: 'Please select an option.',
    pleaseSelectADate:  'Please select a date.',

    // Toast Warnings/Errors/Success messages
    changesSavedSuccessfully: 'Changes saved successfully.',
    couldNotSaveChanges: 'We could not save your changes. Please try again.',
    pleaseFillOutRequiredFields: 'Please fill out all the required fields.',
    maxCharactersReached: 'You have reached the max number of characters.',
    yourChangesWillBeDiscarded: 'Your changes will be discarded.',
    thereIsAProblemLoadingYourResults: 'There is a problem loading your results. Please try again or contact support.',
    tryAgain: 'Try Again',
    uploadAgain: 'Upload Again',
    contactUs: 'Contact Us',
    fileTooLarge: 'The uploaded file size exceeds <b>2 Mb.</b> Please choose a smaller image.',
    unsupportedFileType: 'The uploaded file is not a supported file type. Please choose <b>JPG, JPEG,</b> or <b>PNG.</b>',
    supportModeWarning: 'You are in Support mode - view only',
    removeProfilePhoto: 'Remove the profile photo?',
    yesRemoveIt: 'Yes, Remove it',
    noKeepIt: 'No, Keep it',


    // Form fields
    typeToSearch: 'Type to search',
    noResultsFound: 'No results found.',
    cityOrZipCode: 'City or zipcode',
    currentlyWorkingInThisRole: 'I am currently working in this role',

    // learner
    additionalInformation: 'Additional Information',
    contact: 'Contact',
    currentCourse: 'Current Course',
    documents: 'Documents',
    immunizationRecord: 'Immunization Record',
    programBadges: 'Program Badges',
    changeResume: 'Change Resumé',
    resume: 'Resumé',
    changePhoto: 'Change Photo',
    removePhoto: 'Remove Photo',
    uploadPhoto: 'Upload Photo',
    acceptedPhotosHTML: 'Accepted: <b>JPG</b>, <b>JPEG</b>, or <b>PNG</b>.',
    maximumPhotoSizeHTML: 'Maximum file size is <b>2 Mb</b>.',
    seeMore: 'See More',
    seeLess: 'See Less',
    seeLessDetails: 'See Less Details',

    // 404 Page
    ohNo: 'Oh no...',
    somethingWentWrong: 'Looks like something went wrong.',
    weAreWorkingOnIt: 'We are working on it.',
    backToProfile: 'Back to Profile',


    //Errors and validation
    errors: {
        passwordsMustMatch: 'Passwords must match',
        imageTooSmall: 'The selected image is too small. Try a larger image.',
        errorLoadingData: 'An error occurred loading data'
    },
    unsavedChangesHTML: '<b>You have unsaved changes!</b><br>Please save your changes or continue editing.'
}
